import React from 'react';

// Page 404 (route SPA inconnue).
export function NotFoundPage({ onHome }) {
  return (
    <div className="notfound-page">
      <div style={{ fontSize: '3.5rem' }}>🌍</div>
      <h1 style={{ margin: 0, fontSize: '3rem' }}>404</h1>
      <p style={{ opacity: 0.85 }}>Cette page n'existe pas.</p>
      <button type="button" className="btn primary" onClick={onHome}>Retour a l'accueil</button>
    </div>
  );
}
